import React, { Fragment, useEffect, useState } from "react";
import { useDispatch } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
    containerStyle: { 
        display: "flex", 
        alignItems: "center",
        marginTop: 10
    },
    textFieldStyle: { 
        width: 100 
    },
    buttonStyle: { 
        padding: '10px 10px', 
        marginLeft: 20 
    }
}));

function SearchDrievrs(props) {
    const {t} = useTranslation('complaint');
    const classes = useStyles();

    const [num, setNum] = useState(0);

    const handleDriverIdInput = (event) => {
        props.handleDriverId(event.target.value);
        search(props.rows, event.target.value);
    }

    function search(rows, input) {
        if(rows.length > 0) {
            let rowsCurr = [];
            rows.map((row) => {                
                const driverIdCurr = row.driver_id + '';                
                if(driverIdCurr.includes(input)) {
                    rowsCurr.push(row);                    
                }               
            })
            setNum(rowsCurr.length);
            props.handleRowsTemp(rowsCurr);
        }
    }

    useEffect(() => {
        setNum(0);
        if(props.rows) {
            search(props.rows, props.driverId);
        }
    }, [props.rows])

    return (
        <Fragment>
            <Grid container className={classes.containerStyle}>
                <div style={{ marginRight: 10 }}>{t('driver')}</div>
                <TextField 
                    id="outlined-basic" 
                    variant="outlined"
                    size="small"
                    placeholder={t('driver_id')}
                    onChange={handleDriverIdInput}
                    className={classes.textFieldStyle}
                />
                <div style={{ marginLeft: 20 }}>
                    {num} {t('results')}
                </div>
            </Grid>      
        </Fragment>
    );
}

export default SearchDrievrs;